import {
  GetContentResponse,
  GetVoiceAndToneCurrentAndTargetVectorsResponse
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentServerProxy/types';
import { ChartDataAdapter } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/Summary/Visualizations/adapters/types';

// TODO(jvancamp): Update chart visualization type
export type ProductContent = any;

export class ProductLevelContentAdapter implements ChartDataAdapter<ProductContent> {
  productContent: GetContentResponse;

  currentVoiceAndTone: GetVoiceAndToneCurrentAndTargetVectorsResponse;

  constructor(productContent: GetContentResponse, currentVoiceAndTone: GetVoiceAndToneCurrentAndTargetVectorsResponse) {
    this.productContent = productContent;
    this.currentVoiceAndTone = currentVoiceAndTone;
  }

  transform(): ProductContent {
    const { currentDominantVoice, currentDominantTone } = this.currentVoiceAndTone;
    return { ...this.productContent, currentDominantVoice, currentDominantTone };
  }
}
